import { inject, Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
  name: "rrUiCoreSanitizeHtml",
})
export class UiCoreSanitizeHtmlPipe implements PipeTransform {
  readonly #sanitizer = inject(DomSanitizer);
  transform(value: string | null): unknown {
    return this.#sanitizer.bypassSecurityTrustHtml(value ?? "");
  }
}
